



document.addEventListener("DOMContentLoaded", function () {
  const mainEl = document.querySelector(".detail-main-swiper._single");
  const thumbEl = document.querySelector(".detail-thumb-swiper._single");

  if (!mainEl) return;

  const gallery = mainEl.closest(".detail-gallery");

  const mainPrev = gallery?.querySelector(".detail-main-prev");
  const mainNext = gallery?.querySelector(".detail-main-next");
  const thumbPrev = gallery?.querySelector(".detail-thumb-prev");
  const thumbNext = gallery?.querySelector(".detail-thumb-next");

  let thumbSwiper = null;

  if (thumbEl) {
    thumbSwiper = new Swiper(thumbEl, {
      slidesPerView: 4,
      slidesPerGroup: 4,
      spaceBetween: 8,

      freeMode: false,
      watchSlidesProgress: true,
      slideToClickedSlide: true,

      // 最後のグループから最初へ戻る
      loop: false,
      rewind: true,

      navigation: {
        prevEl: thumbPrev,
        nextEl: thumbNext,
      },

      breakpoints: {
        0: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
        1024: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
      },
    });
  }

  new Swiper(mainEl, {
    slidesPerView: 1,
    slidesPerGroup: 1,

    effect: "fade",

    fadeEffect: {
      crossFade: true,
    },

    autoHeight: true,
    speed: 500,

    // 最後の画像から最初へ戻る
    loop: false,
    rewind: true,

    navigation: {
      prevEl: mainPrev,
      nextEl: mainNext,
    },

    thumbs: thumbSwiper
      ? {
          swiper: thumbSwiper,
          autoScrollOffset: 1,
        }
      : undefined,
  });
});


document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".archive-slider-group._archive")
    .forEach(function (group) {
      const mainEl = group.querySelector(".archive-slider");
      const thumbEl = group.querySelector(".archive-slider-nav");

      const mainPrev = group.querySelector(".detail-main-prev");
      const mainNext = group.querySelector(".detail-main-next");
      const thumbPrev = group.querySelector(".detail-thumb-prev");
      const thumbNext = group.querySelector(".detail-thumb-next");

      if (!mainEl) return;

      let thumbSwiper = null;

      if (thumbEl) {
        thumbSwiper = new Swiper(thumbEl, {
          slidesPerView: 3,
          spaceBetween: 8,
          watchSlidesProgress: true,
          slideToClickedSlide: true,

          // サムネ3枚は固定
          allowTouchMove: false,
        });
      }

      const mainSwiper = new Swiper(mainEl, {
        slidesPerView: 1,
        effect: "fade",

        fadeEffect: {
          crossFade: true,
        },

        loop: false,
        autoHeight: true,
        allowTouchMove: true,
        speed: 500,

        thumbs: thumbSwiper
          ? {
              swiper: thumbSwiper,
            }
          : undefined,
      });

      // 前へ。1枚目なら3枚目へ
      [mainPrev, thumbPrev].forEach(function (button) {
        if (!button) return;

        button.addEventListener("click", function () {
          if (mainSwiper.animating) return;

          if (mainSwiper.isBeginning) {
            mainSwiper.slideTo(mainSwiper.slides.length - 1);
          } else {
            mainSwiper.slidePrev();
          }
        });
      });

      // 次へ。3枚目なら1枚目へ
      [mainNext, thumbNext].forEach(function (button) {
        if (!button) return;

        button.addEventListener("click", function () {
          if (mainSwiper.animating) return;

          if (mainSwiper.isEnd) {
            mainSwiper.slideTo(0);
          } else {
            mainSwiper.slideNext();
          }
        });
      });
    });
});

